import { render, staticRenderFns } from "./editCard.vue?vue&type=template&id=21ed6064&scoped=true"
import script from "./editCard.vue?vue&type=script&lang=js"
export * from "./editCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed6064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ed6064')) {
      api.createRecord('21ed6064', component.options)
    } else {
      api.reload('21ed6064', component.options)
    }
    module.hot.accept("./editCard.vue?vue&type=template&id=21ed6064&scoped=true", function () {
      api.rerender('21ed6064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/platformCard/editCard.vue"
export default component.exports